// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false
};

let base_url = "";
//   base_url = "https://api.sixtnc.com/api";
// base_url = "http://6taxi-api.codiant.com/api";
base_url = "https://taxiwheel-api.codiantdev.com/api";
// base_url = "http://192.249.123.29:5000/api";

class Endpoints {
  AUTH_BASE = base_url + "/auth";
  DRIVER_BASE = base_url + "/admin/driver";
  RIDER_BASE = base_url + "/admin/customer";
  DASHBOARD_BASE = base_url + "/admin/dashboard";
  RIDE_BASE = base_url + "/ride";
  PAYMENT_BASE = base_url + "/admin/payment";
  SETTING_BASE = base_url + "/setting";
  FARE_BASE = base_url + "/fare";
  MAKE_BASE = base_url + "/admin/brand";
  MODEL_BASE = base_url + "/admin/model";
  CATEGORY_BASE = base_url + "/admin/category";

  REFERAL_SYSTEM_BASE = base_url + "/admin";
  PROMO_CODE_BASE = base_url + "/admin/promocode";
  REPORT_BASE = base_url + "/admin/report";
  EMAIL_TEMPLATE_BASE = base_url + "/admin/template";
  MESSAGING_BASE = base_url + "/admin";
  MISCELLANEOUS_BASE = base_url + "";
  MASS_MESSAGE_BASE = base_url + "/admin";
  TEXT_TEMPLATE_BASE = base_url + "/admin/chat/predefined-message";

  RELATED_CATEGORY_BASE = base_url + "/admin/related-category";

  DASHBOARD_ENDPOINTS = {
    GET_HEADER_DETAILS: this.DASHBOARD_BASE,
    GET_LIVE_DRIVERS: this.joinPaths(this.DASHBOARD_BASE, "active-driver"),
    GET_INCOME_DISTRIBUTION: this.joinPaths(this.DASHBOARD_BASE, "income-distribution"),
    GET_USER_GRAPH: this.joinPaths(this.DASHBOARD_BASE, "user-graph")
  };

  AUTH_ENDPOINTS = {
    LOG_IN: this.joinPaths(this.AUTH_BASE, "login"),
    FORGET_PASSWORD: this.joinPaths(this.AUTH_BASE, "forgot-password"),
    RESET_PASSWORD: this.joinPaths(this.AUTH_BASE, "reset-password"),
    CHANGE_PASSWORD: this.joinPaths(this.AUTH_BASE, "change-password"),
    LOGOUT: this.joinPaths(this.AUTH_BASE, "logout")
  };

  DRIVER_ENDPOINTS = {
    GET_DRIVER_LIST: this.DRIVER_BASE,
    ADD_DRIVER: this.DRIVER_BASE,
    ADD_DOCUMENT: type => this.joinPathsWithQueryParams(this.joinPaths(this.DRIVER_BASE, "document"), "type=" + type),
    DRIVER_RIDES_EARNING_LIST: id => this.joinPaths(this.DRIVER_BASE, id, "ride"),
    DRIVER_REFERRAL_EARNING_LIST: id => this.joinPaths(this.DRIVER_BASE, id, "referral-earning"),
    DRIVER_REFERRAL_DRIVER_EARNING_LIST: id => this.joinPaths(this.DRIVER_BASE, id, "referred-driver"),
    DRIVER_REFERRAL_RIDER_EARNING_LIST: id => this.joinPaths(this.DRIVER_BASE, id, "referred-rider"),
    DRIVER_PAYOUT_LIST: id => this.joinPaths(this.DRIVER_BASE, id, "payout"),
    DRIVER_DOCUMENT_LIST: id => this.joinPaths(this.DRIVER_BASE, id, "document"),

    UPDATE_DRIVER: id => this.joinPaths(this.DRIVER_BASE, id, "edit"),
    GET_DRIVER_DETAIL: id => this.joinPaths(this.DRIVER_BASE, id),
    DRIVER_STATUS_UPDATE_URL: id => this.joinPaths(this.DRIVER_BASE, id, "change-status"),
    DELETE_DRIVER: id => this.joinPaths(this.DRIVER_BASE, id),
    DRIVER_LIST_FILE_DOWNLOAD: this.joinPaths(this.DRIVER_BASE, "download-list")
  };

  RIDER_ENDPOINTS = {
    GET_RIDER_LIST: this.RIDER_BASE,
    RIDER_RIDES_LIST: id => this.joinPaths(this.RIDER_BASE, id, "ride"),
    RIDER_REFERRED_DRIVER: id => this.joinPaths(this.RIDER_BASE, id, "referred-driver"),
    RIDER_REFERRED_RIDER: id => this.joinPaths(this.RIDER_BASE, id, "referred-rider"),
    RIDER_PAYOUT_LIST: id => this.joinPaths(this.RIDER_BASE, id, "payout"),
    UPDATE_RIDER: id => this.joinPaths(this.RIDER_BASE, id, "edit"),
    GET_RIDER_DETAIL: id => this.joinPaths(this.RIDER_BASE, id),
    RIDER_STATUS_UPDATE_URL: id => this.joinPaths(this.RIDER_BASE, id, "change-status"),
    DELETE_RIDER: id => this.joinPaths(this.RIDER_BASE, id),
    RIDER_LIST_FILE_DOWNLOAD: this.joinPaths(this.RIDER_BASE, "download-list")
  };

  RIDE_ENDPOINTS = {
    GET_RIDE_LIST: this.RIDE_BASE,
    GET_RIDE_DETAIL: id => this.joinPaths(this.RIDE_BASE, id),
    GET_RIDE_INVOICE: id => this.joinPaths(this.RIDE_BASE, id)
  };

  PROMOCODE_ENDPOINTS = {
    GET_PROMOCODE_LIST: this.PROMO_CODE_BASE,
    ADD_PROMOCODE: this.joinPaths(this.PROMO_CODE_BASE),
    UPDATE_PROMOCODE: id => this.joinPaths(this.PROMO_CODE_BASE, id),
    GET_PROMOCODE_DETAIL: id => this.joinPaths(this.PROMO_CODE_BASE, id),
    PROMOCODE_STATUS_UPDATE_URL: id => this.joinPaths(this.PROMO_CODE_BASE, id, "change-status"),
    DELETE_PROMOCODE: id => this.joinPaths(this.PROMO_CODE_BASE, id),
    PROMOCODE_LIST_CSV_DOWNLOAD: this.joinPaths(this.PROMO_CODE_BASE, "csv-download")
  };

  REFERAL_SYSTEM_ENDPOINTS = {
    GET_DRIVER_LIST: this.REFERAL_SYSTEM_BASE,
    // ADD_DRIVER: this.DRIVER_BASE,

    DRIVER_REFERRAL_LIST_FILE_DOWNLOAD: this.joinPaths(this.DRIVER_BASE, "download-referral-list"),

    RIDER_REFERRAL_LIST_FILE_DOWNLOAD: this.joinPaths(this.RIDER_BASE, "download-referral-list"),

    DRIVER_REFERRAL_LIST: id => this.joinPaths(this.REFERAL_SYSTEM_BASE, "driver"),
    RIDER_REFERRAL_LIST: id => this.joinPaths(this.REFERAL_SYSTEM_BASE, "rider"),

    DRIVER_REFERRAL_Details: id => this.joinPaths(this.REFERAL_SYSTEM_BASE, "driver", id, "driver-details"),
    RIDER_REFERRAL_Details: id => this.joinPaths(this.REFERAL_SYSTEM_BASE, "rider", id, "rider-details"),

    DRIVER_REFERRED_DRIVER_LIST: id => this.joinPaths(this.REFERAL_SYSTEM_BASE, "driver", id, "referred-driver"),
    DRIVER_REFERRED_RIDER_LIST: id => this.joinPaths(this.REFERAL_SYSTEM_BASE, "driver", id, "referred-rider"),
    DRIVER_REFERRED_DRIVER_DETAIL: (id, referralId) => this.joinPaths(this.REFERAL_SYSTEM_BASE, "driver", id, "referred-driver", referralId),
    DRIVER_REFERRED_RIDER_DETAIL: (id, referralId) => this.joinPaths(this.REFERAL_SYSTEM_BASE, "driver", id, "referred-rider", referralId),
    DRIVER_REFERRED_DRIVER_DETAIL_LIST: (id, referralId) => this.joinPaths(this.REFERAL_SYSTEM_BASE, "referred-driver", referralId, "ride"),
    DRIVER_REFERRED_RIDER_DETAIL_LIST: (id, referralId) => this.joinPaths(this.REFERAL_SYSTEM_BASE, "referred-rider", referralId, "ride"),

    DRIVER_REFERRED_DRIVER_DETAIL_LIST_FILE_DOWNLOAD: (id, referralId) => this.joinPaths(this.REFERAL_SYSTEM_BASE, "referred-driver", referralId, "ride", "download"),
    DRIVER_REFERRED_RIDER_DETAIL_LIST_FILE_DOWNLOAD: (id, referralId) => this.joinPaths(this.REFERAL_SYSTEM_BASE, "referred-rider", referralId, "ride", "download"),

    RIDER_REFERRED_DRIVER_LIST: id => this.joinPaths(this.REFERAL_SYSTEM_BASE, "rider", id, "referred-driver"),
    RIDER_REFERRED_RIDER_LIST: id => this.joinPaths(this.REFERAL_SYSTEM_BASE, "rider", id, "referred-rider"),
    RIDER_REFERRED_DRIVER_DETAIL: (id, referralId) => this.joinPaths(this.REFERAL_SYSTEM_BASE, "customer", id, "referred-driver", referralId),
    RIDER_REFERRED_RIDER_DETAIL: (id, referralId) => this.joinPaths(this.REFERAL_SYSTEM_BASE, "customer", id, "referred-rider", referralId),
    RIDER_REFERRED_DRIVER_DETAIL_LIST: (id, referralId) => this.joinPaths(this.REFERAL_SYSTEM_BASE, "referred-driver", referralId, "ride"),
    RIDER_REFERRED_RIDER_DETAIL_LIST: (id, referralId) => this.joinPaths(this.REFERAL_SYSTEM_BASE, "referred-rider", referralId, "ride"),

    RIDER_REFERRED_DRIVER_DETAIL_LIST_FILE_DOWNLOAD: (id, referralId) => this.joinPaths(this.REFERAL_SYSTEM_BASE, "referred-driver", referralId, "ride", "download"),
    RIDER_REFERRED_RIDER_DETAIL_LIST_FILE_DOWNLOAD: (id, referralId) => this.joinPaths(this.REFERAL_SYSTEM_BASE, "referred-rider", referralId, "ride", "download")
  };

  PAYMENT_ENDPOINTS = {
    GET_PAYMENT_FROM_RIDE_LIST: this.joinPaths(this.PAYMENT_BASE, "ride"),
    GET_PAYMENT_FROM_RIDE_DETAILS: id => this.joinPaths(this.PAYMENT_BASE, "ride", id),

    GET_PAYMENT_FROM_RIDE_FILE_DOWNLOAD: this.joinPaths(this.PAYMENT_BASE, "ride", "download"),

    GET_COMMISSION_DISTRIBUTION_FROM_RIDE_LIST: this.joinPaths(this.REPORT_BASE, "commission-distribution"),
    GET_COMMISSION_DISTRIBUTION_FROM_RIDE_DETAILS: id => this.joinPaths(this.RIDE_BASE, id),

    GET_COMMISSION_DISTRIBUTION_FROM_RIDE_LIST_FILE_DOWNLOAD: this.joinPaths(this.PAYMENT_BASE, "commission-distribution", "download"),
    GET_PAYOUT_DRIVER_LIST: this.joinPaths(this.DRIVER_BASE, "payout"),
    GET_PAYOUT_RIDER_LIST: this.joinPaths(this.RIDER_BASE, "payout"),

    GET_PAYOUT_DRIVER_LIST_FILE_DOWNLOAD: this.joinPaths(this.DRIVER_BASE, "payout", "download"),
    GET_PAYOUT_RIDER_LIST_FILE_DOWNLOAD: this.joinPaths(this.RIDER_BASE, "payout", "download")
  };

  SETTING_ENDPOINTS = {
    GET_CATEGORY_LIST: this.joinPaths(this.CATEGORY_BASE),
    GET_CATEGORY_DETAIL: id => this.joinPaths(this.CATEGORY_BASE, id),
    CATEGORY_STATUS_UPDATE_URL: id => this.joinPaths(this.CATEGORY_BASE, id, "change-status"),
    ADD_CATEGORY: this.joinPaths(this.CATEGORY_BASE),
    UPDATE_CATEGORY: id => this.joinPaths(this.CATEGORY_BASE, id),
    DELETE_CATEGORY: id => this.joinPaths(this.CATEGORY_BASE, id),

    GET_RELATED_CATEGORY_LIST: this.joinPaths(this.RELATED_CATEGORY_BASE),

    GET_MAKE_LIST: this.joinPaths(this.MAKE_BASE),
    GET_MAKE_DETAIL: id => this.joinPaths(this.MAKE_BASE, id),
    MAKE_STATUS_UPDATE_URL: id => this.joinPaths(this.MAKE_BASE, id, "change-status"),
    ADD_MAKE: this.joinPaths(this.MAKE_BASE),
    UPDATE_MAKE: id => this.joinPaths(this.MAKE_BASE, id),
    DELETE_MAKE: id => this.joinPaths(this.MAKE_BASE, id),

    GET_MODEL_LIST: this.joinPaths(this.MODEL_BASE),
    GET_MODEL_DETAIL: id => this.joinPaths(this.MODEL_BASE, id),
    MODEL_STATUS_UPDATE_URL: id => this.joinPaths(this.MODEL_BASE, id, "change-status"),
    ADD_MODEL: this.joinPaths(this.MODEL_BASE),
    UPDATE_MODEL: id => this.joinPaths(this.MODEL_BASE, id),
    DELETE_MODEL: id => this.joinPaths(this.MODEL_BASE, id),

    GET_FARE_LIST: this.joinPaths(this.FARE_BASE),
    FARE_STATUS_UPDATE_URL: id => this.joinPaths(this.FARE_BASE, id, "change-status"),
    UPDATE_FARE: id => this.joinPaths(this.FARE_BASE, id),

    GET_SETTING_LIST: this.joinPaths(this.SETTING_BASE),
    UPDATE_SETTING: id => this.joinPaths(this.SETTING_BASE, id),

    //TEXT_TEMPLATE
    GET_TEXT_TEMPLATE_LIST: this.joinPaths(this.TEXT_TEMPLATE_BASE),
    GET_TEXT_TEMPLATE_DETAIL: id => this.joinPaths(this.TEXT_TEMPLATE_BASE, id),
    TEXT_TEMPLATE_STATUS_UPDATE_URL: id => this.joinPaths(this.TEXT_TEMPLATE_BASE, id, "change-status"),
    ADD_TEXT_TEMPLATE: this.joinPaths(this.TEXT_TEMPLATE_BASE),
    UPDATE_TEXT_TEMPLATE: id => this.joinPaths(this.TEXT_TEMPLATE_BASE, id),
    DELETE_TEXT_TEMPLATE: id => this.joinPaths(this.TEXT_TEMPLATE_BASE, id)
  };

  REPORT_ENDPOINTS = {
    GET_RIDER_REPORT: this.joinPaths(this.REPORT_BASE, "rider"),
    GET_DRIVER_REPORT: this.joinPaths(this.REPORT_BASE, "driver"),
    GET_COMMISION_REPORT: this.joinPaths(this.REPORT_BASE, "commission-distribution"),
    GET_DRIVER_PAYOUT_REPORT: this.joinPaths(this.REPORT_BASE, "driver-payout"),
    GET_RIDER_PAYOUT_REPORT: this.joinPaths(this.REPORT_BASE, "customer-payout"),
    GET_DRIVER_PARTICULAR_REPORT: this.joinPaths(this.REPORT_BASE, "driver-particular"),
    GET_TRIP_DETAIL_REPORT: this.joinPaths(this.REPORT_BASE, "trip-detail"),
    GET_COMPLETED_RIDE_REPORT: this.joinPaths(this.REPORT_BASE, "completed-ride"),

    //DOWNLOAD REPORT IN CSV FORMAT
    GET_RIDER_REPORT_CSV_DOWNLOAD: this.joinPaths(this.REPORT_BASE, "customer", "download"),
    GET_DRIVER_REPORT_CSV_DOWNLOAD: this.joinPaths(this.REPORT_BASE, "driver", "download"),
    GET_COMMISION_REPORT_CSV_DOWNLOAD: this.joinPaths(this.REPORT_BASE, "commission-distribution", "download"),
    GET_DRIVER_PAYOUT_REPORT_CSV_DOWNLOAD: this.joinPaths(this.DRIVER_BASE, "payout", "download"),
    GET_RIDER_PAYOUT_REPORT_CSV_DOWNLOAD: this.joinPaths(this.RIDER_BASE, "payout", "download"),
    GET_DRIVER_PARTICULAR_REPORT_CSV_DOWNLOAD: this.joinPaths(this.REPORT_BASE, "driver-particular", "download"),
    GET_TRIP_DETAIL_REPORT_CSV_DOWNLOAD: this.joinPaths(this.REPORT_BASE, "trip-detail", "download"),
    GET_COMPLETED_RIDE_REPORT_CSV_DOWNLOAD: this.joinPaths(this.REPORT_BASE, "completed-ride", "download")
  };

  EMAIL_TEMPLATE_ENDPOINTS = {
    GET_TEMPLATE_TYPE: this.joinPaths(this.EMAIL_TEMPLATE_BASE, "type"),
    GET_TEMPLATE_DETAIL: id => this.joinPaths(this.EMAIL_TEMPLATE_BASE, id),
    UPDATE_EMAIL_TEMPLATE: id => this.joinPaths(this.EMAIL_TEMPLATE_BASE, id)
  };

  MESSAGING_ENDPOINTS = {
    GET_DRIVERS_FOR_STATUS: this.joinPaths(this.MESSAGING_BASE, "driver"),
    GET_CUSTOMERS_FOR_STATUS: this.joinPaths(this.MESSAGING_BASE, "customer")
  };

  MISCELLANEOUS_ENDPOINTS = {
    GET_SEATING_CAPACITY_LIST: this.joinPaths(this.MISCELLANEOUS_BASE, "seating-capacity")
  };

  MASS_MESSAGE_ENDPOINTS = {
    DRIVER_EMAIL_MESSAGE: this.joinPaths(this.MASS_MESSAGE_BASE, "driver-email-message"),
    MASS_MESSAGE_CUSTOMER_EMAIL: this.joinPaths(this.MASS_MESSAGE_BASE, "customer-email-message"),
    MASS_MESSAGE_DRIVER_NOTIFICATION: this.joinPaths(this.MASS_MESSAGE_BASE, "driver-message"),
    MASS_MESSAGE_CUSTOMER_NOTIFICATION: this.joinPaths(this.MASS_MESSAGE_BASE, "customer-message")
  };

  private joinPaths(...params) {
    const newUrl = params.join("/");
    return newUrl;
  }

  private joinPathsWithQueryParams(...params) {
    const newUrl = params.join("?");
    return newUrl;
  }
}

export const API = new Endpoints();



// WEBPACK FOOTER //
// ./src/environments/environment.ts